import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
interface FooterProps {
  onPrivacyClick: () => void;
  onTermsClick: () => void;
}
export function Footer({
  onPrivacyClick,
  onTermsClick
}: FooterProps) {
  const {
    t
  } = useTranslations();
  return <footer className="bg-[#064E3B] text-white pt-16 pb-8" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-131">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-132">
            <div className="flex items-center mb-6" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/oxFWMvdwUBRjCt1riBg7DA/Asset_44x.png" alt="Brixen Funding" className="h-8 w-auto brightness-0 invert" data-id="element-134" />
            </div>
            <p className="text-gray-300 text-sm mb-6" data-id="element-135">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4" data-id="element-136">
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-137">
                <Facebook className="w-5 h-5" data-id="element-138" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-139">
                <Twitter className="w-5 h-5" data-id="element-140" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-141">
                <Linkedin className="w-5 h-5" data-id="element-142" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-143">
                <Instagram className="w-5 h-5" data-id="element-144" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-145">
            <h4 className="text-lg font-bold mb-6" data-id="element-146">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-147">
              <li data-id="element-148">
                <a href="#about" className="hover:text-[#00E676] transition-colors" data-id="element-149">
                  {t('nav.aboutUs')}
                </a>
              </li>
              <li data-id="element-150">
                <a href="#funding" className="hover:text-[#00E676] transition-colors" data-id="element-151">
                  {t('nav.funding')}
                </a>
              </li>
              <li data-id="element-152">
                <a href="#how-it-works" className="hover:text-[#00E676] transition-colors" data-id="element-153">
                  {t('nav.howItWorks')}
                </a>
              </li>
              <li data-id="element-154">
                <a href="#testimonials" className="hover:text-[#00E676] transition-colors" data-id="element-155">
                  {t('nav.testimonials')}
                </a>
              </li>
              <li data-id="element-156">
                <a href="#contact" className="hover:text-[#00E676] transition-colors" data-id="element-157">
                  {t('contact.email')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-158">
            <h4 className="text-lg font-bold mb-6" data-id="element-159">{t('footer.contact')}</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-160">
              <li data-id="element-161">390 NE 191ST ST</li>
              <li data-id="element-162">Miami, FL 33179</li>
              <li data-id="element-163">(786) 272-6132</li>
              <li data-id="element-164">info@brixenfunding.com</li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-165">
            <h4 className="text-lg font-bold mb-6" data-id="element-166">{t('footer.hoursTitle')}</h4>
            <p className="text-sm text-gray-300 mb-2" data-id="element-167">{t('footer.hoursDay')}</p>
            <p className="text-lg font-semibold text-[#00E676]" data-id="element-168">
              {t('footer.hoursTime')}
            </p>
            <p className="text-sm text-gray-400 mt-4" data-id="element-169">
              {t('footer.hoursClosed')}
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8" data-id="element-170">
          {/* Disclaimer Text - Above Copyright */}
          <div className="mb-8 text-xs text-gray-400 text-center max-w-5xl mx-auto leading-relaxed space-y-4" data-id="element-171">
            <p data-id="element-172">{t('footer.disclaimer1')}</p>
            <p data-id="element-173">{t('footer.disclaimer2')}</p>
            <p data-id="element-174">{t('footer.disclaimer3')}</p>
          </div>

          {/* Copyright and Links */}
          <div className="flex flex-col md:flex-row justify-between items-center pt-6 border-t border-gray-700" data-id="element-175">
            <p className="text-xs text-gray-400 text-center md:text-left mb-4 md:mb-0" data-id="element-176">
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-6 text-xs text-gray-400" data-id="element-177">
              <button onClick={onPrivacyClick} className="hover:text-white transition-colors cursor-pointer" data-id="element-178">
                {t('footer.privacy')}
              </button>
              <button onClick={onTermsClick} className="hover:text-white transition-colors cursor-pointer" data-id="element-179">
                {t('footer.terms')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}